/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Full_BlockInputs */

const en_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert full block`)
};

const fr_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer un bloc plein`)
};

const de_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständigen Block einfügen`)
};

const it_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci blocco completo`)
};

const ru_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить полный блок`)
};

const es_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar bloque completo`)
};

const zh_cn2_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入完整块`)
};

const ja_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全なブロックを挿入`)
};

const hi_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा ब्लॉक डालें`)
};

const pt_pt2_insert_full_block = /** @type {(inputs: Insert_Full_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir bloco completo`)
};

/**
* | output |
* | --- |
* | "Insert full block" |
*
* @param {Insert_Full_BlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_full_block = /** @type {((inputs?: Insert_Full_BlockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Full_BlockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_full_block(inputs)
	if (locale === "de") return de_insert_full_block(inputs)
	if (locale === "it") return it_insert_full_block(inputs)
	if (locale === "ru") return ru_insert_full_block(inputs)
	if (locale === "es") return es_insert_full_block(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_full_block(inputs)
	if (locale === "ja") return ja_insert_full_block(inputs)
	if (locale === "hi") return hi_insert_full_block(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_full_block(inputs)
	return en_insert_full_block(inputs)
});